import { render, staticRenderFns } from "./appModalities.vue?vue&type=template&id=17e5b202&scoped=true"
import script from "./appModalities.vue?vue&type=script&lang=js"
export * from "./appModalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e5b202",
  null
  
)

export default component.exports